import React from 'react';
import { fileKindOf, linesOf, totalsOfLines } from '../../quoteFile.js';

// The compact list of quotes and contrataciones (one row per quote, its earlier versions inside the
// file): the same rows in «Cotizaciones y pagos», the company and Contactos/Personas. Every row opens
// the same file (QuoteFile) in «Cotizaciones y pagos»: there is no other path to edit, send or accept.

/** Opens the file of a quote from anywhere (App and the demo route it to «Cotizaciones y pagos»). */
export const openQuoteFile = (quoteId) => window.dispatchEvent(new CustomEvent('oike:navigate', { detail: { page: 'quotes', quoteId } }));

export function money(n, currency) {
  if (!n) return '';
  try { return new Intl.NumberFormat('es', { style: 'currency', currency, maximumFractionDigits: 2 }).format(n); }
  catch { return `${currency} ${Number(n).toLocaleString('es')}`; }
}
export const totalsText = (t, currency) => [t.once ? money(t.once, currency) : '', t.monthly ? `${money(t.monthly, currency)}/mes` : ''].filter(Boolean).join(' + ') || 'Sin importes';
export const recordTotalText = (f = {}) => totalsText(totalsOfLines(linesOf(f)), f['Quote Currency'] || 'USD');

/** The record that represents a chain: its latest version (the earlier ones are history). */
export const headOf = (c) => (c.current || c.versions[c.versions.length - 1]).record;

const TONE = { contract: '#1E7B4F', quote: '#6B5CA5', earlier: 'var(--globant-muted)' };

/** chains (src/quoteChains.js); titleOf(chain); subtitleOf(chain); onOpen(chain) (default: open its file). */
export default function QuoteList({ chains, titleOf, subtitleOf = () => '', onOpen = null, emptyText = 'Sin cotizaciones.' }) {
  if (!chains.length) return <div style={{ fontSize: 12, color: 'var(--globant-muted)', padding: '8px 0' }}>{emptyText}</div>;
  return (
    <div style={{ display: 'grid', gap: 6, gridTemplateColumns: 'minmax(0, 1fr)' }}>
      {chains.map(c => {
        const rec = headOf(c);
        const f = rec.fields || {};
        const k = fileKindOf(f);
        const sub = subtitleOf(c);
        const earlier = c.versions.length - 1;
        return (
          <button key={c.id} type="button" onClick={() => (onOpen ? onOpen(c) : openQuoteFile(rec.id))}
            className="card" style={{ textAlign: 'left', padding: '10px 12px', cursor: 'pointer', display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'baseline', border: '1px solid var(--globant-border)', width: '100%' }}>
            <span style={{ fontSize: 10, fontWeight: 700, color: TONE[k.kind], textTransform: 'uppercase', letterSpacing: 0.5 }}>{k.label}</span>
            <b style={{ flex: '1 1 200px', fontSize: 13, minWidth: 0 }}>{titleOf(c)}</b>
            <span style={{ fontSize: 12 }}>{recordTotalText(f)}</span>
            <span style={{ fontSize: 11, color: 'var(--globant-muted)' }}>{k.state}{earlier > 0 ? ` · ${earlier} ${earlier === 1 ? 'versión anterior' : 'versiones anteriores'}` : ''}{c.anomalies.length ? ' · revisar' : ''}</span>
            {sub && <span style={{ flexBasis: '100%', fontSize: 11, color: 'var(--globant-muted)' }}>{sub}</span>}
          </button>
        );
      })}
    </div>
  );
}
